export const getDebugParams = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return {
    disableCache: urlParams.has('disableCache'),
    apiDelayMs: parseInt(urlParams.get('apiDelayMs') ?? '0'),
  }
}
